var map = {
	"./tech-excel.svg": 1980,
	"./tech-git.svg": 1981,
	"./tech-google-sheets.svg": 1982,
	"./tech-gray-chatgpt.svg": 1254,
	"./tech-gray-excel.svg": 1255,
	"./tech-gray-git.svg": 1256,
	"./tech-gray-google-sheets.svg": 1257,
	"./tech-gray-jupyter.svg": 1258,
	"./tech-gray-multiple.svg": 1259,
	"./tech-gray-other.svg": 1260,
	"./tech-gray-powerbi.svg": 1261,
	"./tech-gray-python.svg": 1262,
	"./tech-gray-r.svg": 1263,
	"./tech-gray-sql.svg": 1264,
	"./tech-gray-tableau.svg": 1265,
	"./tech-gray-theory.svg": 1266,
	"./tech-powerbi.svg": 1983,
	"./tech-python (2).svg": 1984,
	"./tech-python.svg": 1985,
	"./tech-r.svg": 1986,
	"./tech-responsive-artificial-intelligence.svg": 525,
	"./tech-responsive-chatgpt.svg": 587,
	"./tech-responsive-data.svg": 588,
	"./tech-responsive-excel.svg": 589,
	"./tech-responsive-git.svg": 590,
	"./tech-responsive-google-sheets.svg": 591,
	"./tech-responsive-jupyter.svg": 592,
	"./tech-responsive-langchain.svg": 593,
	"./tech-responsive-multiple.svg": 594,
	"./tech-responsive-powerbi.svg": 595,
	"./tech-responsive-powerpoint.svg": 596,
	"./tech-responsive-python.svg": 597,
	"./tech-responsive-r.svg": 598,
	"./tech-responsive-sql.svg": 599,
	"./tech-responsive-tableau.svg": 600,
	"./tech-responsive-theory.svg": 601,
	"./tech-sql.svg": 1987,
	"./tech-tableau.svg": 1988,
	"./tech-theory.svg": 1989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3976;